import React from 'react';
import { Undo } from 'shared/assets/icons';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import { PopupMenu, PopupMenuTitle } from 'shared/components/ui/popup-menu';
import {
  ActiveFilter,
  FilterGroup as FilterGroupType,
} from 'shared/types/filter';
import { ID } from 'shared/types/id';

import { FilterGroup } from './filter-group';

export type FilterContextMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children'
> & {
  title: string;
  options: FilterGroupType[];
  activeOptions: ActiveFilter[];
  onOption: (
    idOrOptions:
      | ID
      | { id: ID; value?: string | string[]; min?: number; max?: number },
    value?: string | string[],
  ) => void;
  onReset: () => void;
};

export const FilterContextMenu: React.FC<FilterContextMenuProps> = ({
  title,
  options,
  onOption,
  activeOptions,
  onReset,
  ...rest
}) => (
  <PopupMenu {...rest}>
    <PopupMenuTitle
      title={title}
      end={
        activeOptions.length ? (
          <IconButton
            icon={Undo}
            onClick={onReset}
            size={Sizes.Small}
            color={Colors.Default}
          />
        ) : undefined
      }
      hasBottomBorder={!!options.length}
    />
    {options.map((group, index) => (
      <FilterGroup
        key={group.id}
        group={group}
        onOption={onOption}
        activeOptions={activeOptions}
        hasBottomBorder={index < options.length - 1}
      />
    ))}
  </PopupMenu>
);
